/* import __COLOCATED_TEMPLATE__ from './legacy-station-feature.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();